<template>
    <div class="question-price">
        <InputRange
            :id="question.id"
            v-model="answerModel"
            :max="question.max"
            :max-label="maxLabel"
            :min="question.min"
            :min-label="minLabel"
            :value-formatter="formatter"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type {
    QuestionnaireAnswerInput,
    QuestionnaireQuestionPriceFragment,
} from '@/graphql/api'

import InputRange from '@/components/ui/inputs/range/InputRange.vue'
import { useMoneyFormatter } from '@/plugins/money-formatter.ts'
import { useCurrency } from '@/plugins/currency.ts'

const props = defineProps<{
    question: QuestionnaireQuestionPriceFragment
    answer: QuestionnaireAnswerInput | undefined
}>()

const emit = defineEmits<{
    'update:answer': [answer: QuestionnaireAnswerInput | undefined]
}>()

const answerModel = computed({
    get: (): number => props.answer?.answer?.number?.number || 0,
    set(answer: number) {
        emit('update:answer', {
            answer: { number: { number: answer } },
            question: {
                referenceId: props.question.id,
                title: props.question.title,
            },
        })
    },
})

const currency = useCurrency()

const format = useMoneyFormatter()

const formatter = (price: number) =>
    format({ amount: price, currency: currency.value })

const minLabel = computed(() => formatter(props.question.min))
const maxLabel = computed(() => formatter(props.question.max))
</script>

<style lang="scss" scoped>
.question-price {
    margin: 160px auto 0;
    max-width: 840px;
}
</style>
